'use strict';

(function () {

    const MIN_VISIBLE_MS = 450;

    const loader = document.getElementById('page-loader');
    if (!loader) return;

    const video = document.getElementById('page-loader-video');
    const starsLayer = document.getElementById('page-loader-stars');
    const REDUCE_MOTION = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let failsafeTimer = null;
    let pendingHref = null;
    let navigationTimer = null;
    let starInterval = null;

    function playVideo() {
        if (!video || REDUCE_MOTION) return;
        try {
            video.currentTime = 0;
            const p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (err) {}
    }

    function stopVideo() {
        if (!video) return;
        try { video.pause(); } catch (err) {}
    }

    function spawnStar() {
        if (!starsLayer) return;
        const star = document.createElement('span');
        star.className = 'loader-star';
        if (Math.random() < 0.28) star.classList.add('loader-star--red');

        const capacidad = Math.random() * 14 + 8;
        star.style.fontSize = capacidad + 'px';
        star.style.left = (Math.random() * 100) + 'vw';

        const duration = Math.random() * 2.5 + 2.5;
        star.style.animationDuration = duration + 's';
        star.textContent = '\u2605';

        starsLayer.appendChild(star);
        setTimeout(function () {
            if (star.parentNode === starsLayer) star.remove();
        }, duration * 1000 + 200);
    }

    function startStars() {
        if (REDUCE_MOTION || !starsLayer || starInterval) return;
        for (let i = 0; i < 6; i++) spawnStar();
        starInterval = setInterval(spawnStar, 240);
    }

    function stopStars() {
        if (starInterval) {
            clearInterval(starInterval);
            starInterval = null;
        }
        if (starsLayer) starsLayer.innerHTML = '';
    }

    function show() {
        loader.classList.add('is-active');
        loader.setAttribute('aria-hidden', 'false');
        playVideo();
        startStars();
        clearTimeout(failsafeTimer);
        failsafeTimer = setTimeout(hide, MIN_VISIBLE_MS + 8000);
    }

    function hide() {
        loader.classList.remove('is-active');
        loader.setAttribute('aria-hidden', 'true');
        stopVideo();
        stopStars();
        clearTimeout(failsafeTimer);
        clearTimeout(navigationTimer);
        failsafeTimer = null;
        navigationTimer = null;
        pendingHref = null;
    }

    function isInternalNavigation(link) {
        if (!link || !link.href) return false;
        if (link.target && link.target !== '_self') return false;
        if (link.hasAttribute('download')) return false;

        const url = new URL(link.href, window.location.href);

        if (url.origin !== window.location.origin) return false;
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
        if (url.pathname === window.location.pathname && url.hash) return false;
        if (url.pathname.indexOf('/checkout') === 0) return false;
        if (url.pathname.indexOf('/cart/change') === 0) return false;

        return true;
    }

    function beginDelayedNavigation(href) {
        pendingHref = href;
        show();
        navigationTimer = setTimeout(function () {
            if (pendingHref) window.location.href = pendingHref;
        }, MIN_VISIBLE_MS);
    }

    document.addEventListener('click', function (e) {
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const link = e.target.closest('a');
        if (!isInternalNavigation(link)) return;

        const interactive = e.target.closest('button, input, select, textarea, [role="button"], [data-fav-id], .fav-btn');
        if (interactive && link.contains(interactive)) return;

        e.preventDefault();
        const href = link.href;

        setTimeout(function () {
            if (!pendingHref) beginDelayedNavigation(href);
        }, 0);
    });

    document.addEventListener('submit', function (e) {
        const form = e.target;
        if (!form) return;
        const action = form.getAttribute('action') || '';
        if (action !== '/cart' || !form.classList.contains('cart-form')) return;
        setTimeout(function () {
            if (!e.defaultPrevented) show();
        }, 0);
    });

    window.addEventListener('pageshow', hide);
    document.addEventListener('visibilitychange', function () {
        if (!document.hidden && !pendingHref) hide();
    });

})();